var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"docScroll",attrs:{"id":"faqs"}},[_c('HeaderTemplate',{staticClass:"mb-12",attrs:{"data":_vm.contentHeader}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }